<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Table, type TableColumnType } from 'ant-design-vue'
import { genRewardNoResettleColumns, REWARD_NO_RESETTLE_DATA_SOURCE } from '../../tools'
const [name] = createNamespace('GroundAttachCompStandardDisplay')
export default defineComponent({
  name,
  props: {
    data: {
      type: Object as PropType<Partial<ApiJtProj.CompStandardData>>,
      default: () => ({})
    }
  },
  setup(props) {
    const columns: TableColumnType[] = [
      ...genRewardNoResettleColumns(),
      {
        title: '标准(元/单位)',
        dataIndex: 'standard',
        width: 150,
        customRender({ record }) {
          return props.data?.[record.key]
        }
      }
    ]
    return () => <Table pagination={false} columns={columns} dataSource={REWARD_NO_RESETTLE_DATA_SOURCE} size='small' />
  }
})
</script>
